/**
* Loads stage 1 configuration
**/
function load_stage_1(){
	//Sets global variables
	selected_type = null;
	clear_stage();
	//scale.val(2.5);
	// scale.change();
	custom_tile_container = {};
	custom_tile_data = {};
	stage.removeAllChildren();
	stage.addChild(draw_watermark());
	canvas_container.addChild(draw_all_types());
	stage.addChild(canvas_container);
	// drag_watermark();
	stage.update();	
}


/**
* Loads stage 2 configuration
**/
function load_stage_2(){
	draw_with_drag_layer();
// 	zoom_level_fix();
// 	tile_update();
}


/**
* Loads stage 3 configuration
**/
function load_stage_3(){
	if(previous_stage < current_stage) {
		real_points_reset = Object.assign({}, selected_type.real_points);
	}
	tile_update();
	draw_with_drag_layer();
	// drag_watermark();
}


/**
* Loads stage 4 configuration
**/
function load_stage_4(){
	// normal_load_action();
	tile_update();
	/* if(current_stage >= 6) {
	for (var custom_index  in custom_tile_data) {
		resize_custom_tile(custom_index.split('_')[0], custom_index.split('_')[1]);
	}
	} */
	// jQuery("#tile-primary input[type='radio']:checked").trigger('click');
}


/**
* Loads stage 5 configuration
**/
function load_stage_5(){
	// normal_load_action();
	tile_update();
	/* if(current_stage >= 6) {
	for (var custom_index  in custom_tile_data) {
		resize_custom_tile(custom_index.split('_')[0], custom_index.split('_')[1]);
	}
	} */
}


/**
* Loads stage 6 configuration
**/
function load_stage_6(){
	// normal_load_action();
	tile_update();
	// drag_watermark();
	/*for (var custom_index  in custom_tile_data) {
		resize_custom_tile(custom_index.split('_')[0], custom_index.split('_')[1]);
	}*/
}


/**
* Loads stage 7 configuration
**/
function load_stage_7(){
	// normal_load_action();
	tile_update();
	// drag_watermark();
	/* for (var custom_index  in custom_tile_data) {
		resize_custom_tile(custom_index.split('_')[0], custom_index.split('_')[1]);
	} */
}


/**
* Loads stage 8 configuration
**/
function load_stage_8(){
	// normal_load_action();
	tile_update();
	/* for (var custom_index  in custom_tile_data) {
		resize_custom_tile(custom_index.split('_')[0], custom_index.split('_')[1]);
	} */
	refresh_report();
	// drag_watermark();
}

jQuery(document).ready(function(){
	jQuery(".reset-btn").click(function(){
		switch(parseInt(current_stage)) {
			case 1:
				alert(jQuery('.sid-floor-shapes-list .room-shape-input:checked').val());
			break;
			case 2:
				init_dimentions();
				init_process_vars();
				load_step(2);
				selected_type.real_points = JSON.parse(JSON.stringify(real_points_reset));
				jQuery("#unit_system_metric").click();
				layers_reload(true);
				// scale_change(1.75, 1.5);
			break;
			case 3:
				selected_type.real_points = JSON.parse(JSON.stringify(real_points_reset));
				draw_with_drag_layer();
				// tile_update();
			break;
			case 4:
				selected_type.none_tiles_areas = [];
				none_tile_areas_container.empty();
				none_tile_poligons.removeAllChildren();
				stage.update();
				jQuery(".none_tile_area_element").empty();
			break;
			case 5:
				jQuery("#color-primary input[type='radio']:first").prop('checked', true);
				jQuery("#tile-primary input[type='radio']:first").trigger('click');
				tile_update();
				
			break;
			case 6:
				jQuery("#color-custom input[type='radio']:first").prop('checked', true);
				jQuery("#tile-custom input[type='radio']:first").trigger('click');
				jQuery("#tile-primary input[type='radio']:checked").trigger('click');
				custom_tile_container = {};
				custom_tile_data = {};
			break;
			case 7:
				fill_edges_and_corners(false);
				normal_load_action();
			break;
			case 8:

			break;
		}
	});

	// jQuery(document).on('click',".sid-add-to-cart-btn",function(){
    //     let cartBtn = jQuery(this);
    //     cartBtn.css('pointer-events', 'none');
    //     cartBtn.text('Adding...');
	// 	var clearCart = jQuery("#sid-clear-cart").is(":checked") ? '1' : '0';
	// 	jQuery.ajax({
	// 		url: adminUrl,
	// 		type: "POST",
	// 		dataType: "json",
	// 		data: { action : "fd_add_to_cart",  items : selected_items, clearcart : clearCart, nonce: nonce},
	// 		success: function(response){
	// 			if(response.success) {
	// 			    selected_items['cart'] = [];
	// 			    cartBtn.removeAttr('style');
	// 			    cartBtn.text('Add to Cart');
	// 			    getRefreshedCart();
	// 			    jQuery(".sid-custom-design-confirm").css('display','flex');
	// 			    // alert("Products has been added to the cart");
	// 			}
	// 		},
	// 		error: function(error){

	// 		}
	// 	});

	// });
	
	jQuery(document).on('click',".sid-custom-design-confirm-close",function(){
    	jQuery(".sid-custom-design-confirm").hide();
	});
	
	jQuery(document).on('click',".sid-new-custom-design",function(){
	    jQuery(".sid-custom-design-confirm").hide();
	    load_step(1);
	});
	

	
	function getRefreshedCart(){
	    jQuery.ajax({
			url: "/?wc-ajax=get_refreshed_fragments",
			type: "POST",
			dataType: "json",
			data: { time: Date.now() },
			success: function(resp){
				jQuery.each(resp.fragments, function (key, val) {
				    if(key == "div.widget_shopping_cart_content"){
                        jQuery('.widget_shopping_cart').html(val);
				    } else if(key == "span.wd-cart-number_wd") {
				        jQuery('.woodmart-cart-icon').html(val);
				    } else if(key == "span.wd-cart-subtotal_wd") {
				        jQuery('.woodmart-cart-totals').html(val);
				    } 
                });
                
			},
			error: function(error){
                
			}
		});
	}
	
    jQuery(document).on('click',"a.remove",function(e){
        
        if(jQuery("#sid-designed-canvas").length > 0){
            getRefreshedCart();
        }

	});
    
	jQuery(document).on('click',".sid-modal-close",function() {
        jQuery('.sid-modal').css('display','none');
	});
	
	jQuery(document).on('click',".sid-save-design-action",function(){
		
		jQuery("#sid-save-design").css('display','flex');
		let saveAction = jQuery(this);

		fd_cd_id = 0;
		var update_design = "0";
		jQuery("#fd_custom_design_error").hide();
		if(saveAction.attr('data-type') == 'savewithname'){

			jQuery("#sid-custom-design-name").removeAttr('style');
			if(jQuery("#sid-custom-design-name").val() == ""){
				jQuery("#sid-custom-design-name").css('border','2px solid #ff0000');
				return true;
			}
			if((jQuery("#sid-update-design").length > 0 &&  jQuery("#sid-update-design").is(":checked")) || jQuery("#sid-update-design").length == 0) {
			    update_design = "1";
			} else {
				update_design = "0";
			}
			fd_cd_id = jQuery("#sid-loaded-custom-design").val();
			fd_cd_name = jQuery("#sid-custom-design-name").val();

		} else if(saveAction.attr('data-type') == 'viewcustomdesign'){
			fd_cd_id = saveAction.attr('data-id');
		} else if(saveAction.attr('data-type') == 'loadcustomdesign'){

			fd_cd_id = jQuery("#sid-saved-designs-list").val();
			fd_cd_name = jQuery("#sid-saved-designs-list option:selected").text();
			jQuery(".sid-modal-close").click();
			
		} else if(saveAction.attr('data-type') == 'signin'){

			jQuery(".sid-user-login-notification").hide();
			jQuery(".sid-user-try-again-notification").show();
			jQuery(".sid-signin-btn").hide();
			jQuery(".sid-try-again-btn").show();
			var win = window.open(saveAction.attr('data-page'), '_blank');
			if (win) {
				//Browser has allowed it to be opened
				win.focus();
			} else {
				//Browser has blocked it
				alert('Please allow popups for the website');
			}
			return true;
		} else {
		    update_design = jQuery("#sid-loaded-custom-design").attr("loaded");
		}
		
		

		var saveBtnText = saveAction.text();
		saveAction.css('pointer-events', 'none');
		saveAction.text('Please wait...');
		

		jQuery.ajax({
			url: adminUrl,
			type: "POST",
			dataType: "json",
			data: { 
				action : "fd_save_custom_design",
				type: saveAction.attr('data-type'),
				name: fd_cd_name,
				data: getDesignData(),
				image: getDesignImage(),
				fd_cd_id: fd_cd_id,
				update_design: update_design,
				nonce: nonce},
			success: function(response){
				saveAction.removeAttr('style');
				saveAction.text(saveBtnText);
				var cd_data;
				if(response.saved) {
					jQuery("#sid-save-design-content").html(response.content);

					setTimeout(function(){
						jQuery('.sid-modal').css('display','none');
					},3000);
				} else {

					if (saveAction.attr('data-type') == 'loadcustomdesign') {
                        
                        jQuery("#sid-loaded-custom-design").attr("loaded","1");
                        jQuery("#sid-loaded-custom-design").val(fd_cd_id);
                        jQuery("#sid-loaded-custom-design").attr("title", jQuery("#sid-saved-designs-list option:selected").text());
						cd_data = JSON.parse(response.content);
						selected_type = cd_data.selected_type;
						
						edges_and_corners = cd_data.edges_and_corners;
						scale.val(cd_data.scale);
						scale.attr("data-previous", cd_data.scale_previous);
						matriz_data = cd_data.matriz;
						custom_tile_data = cd_data.custom_tile_data;
						
						scale_changed = true;
						// scale.val(cd_data.scale);
						// scale.attr("data-previous", cd_data.scale_previous);
						custom_design_imported = true; 
						
						jQuery("#" + cd_data.primary_tile ).attr('checked',true);
						jQuery("#" + cd_data.primary_color ).attr('checked',true);
						
						matriz_changed = true;
						none_tile_poligons = new createjs.Container();
						current_stage = parseInt(cd_data.current_stage);
						previous_stage = parseInt(cd_data.previous_stage);
						room_type_fields(selected_type.type);

						if(current_stage > 1){
							
							if(current_stage==1){
								jQuery(".sid-canvas .sid-designed-home").show();
								jQuery(".sid-canvas .sid-wrapper").hide();
								jQuery(".sid-steps-buttons").css('display','none');
							}else{
								jQuery(".sid-canvas .sid-wrapper").show();
								jQuery(".sid-canvas .sid-designed-home").hide();
								jQuery(".sid-steps-buttons").css('display','flex');
								// body.removeClass("init-step");
							}
							
							if(current_stage == 8 ) {
						        load_step(7);
						        load_step(8);
						    } else {
						        load_step(current_stage);
	    						zoom_level_fix();
    							select_menu();    
						    }
						}
						
						jQuery("#unit_system_" + cd_data.unit_system).click();

						scale_action_change();

						jQuery(".sid-modal-close").click();
						   
						 
					
							
						
					} else if (saveAction.attr('data-type') == 'viewcustomdesign') {

						cd_data = JSON.parse(response.content);
						cd_data.image;
					
					} else if (saveAction.attr('data-type') == 'savewithname') {

						jQuery("#fd_custom_design_error").html(response.error.fd_custom_design_error);
						jQuery("#fd_custom_design_error").show();
					
					} else {
						jQuery("#sid-save-design-content").html(response.content);
					}
				}
			},
			error: function(error){
				saveAction.removeAttr('style');
				saveAction.text(saveBtnText);
			}
		});

	})

});